// extracted by mini-css-extract-plugin
module.exports = {"AwardCard":"styles_AwardCard__QFtql","height":"styles_height__6LOsJ"};